import { useEffect } from 'react';
import { Check } from 'lucide-react';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';

const BENEFITS: Array<{ title: string; description: string }> = [
    {
        title: 'Your HDE Ticket',
        description: 'with QR code for the evening',
    },
    {
        title: 'A personalised project brief',
        description: 'based on your building plans',
    },
    {
        title: 'Design boards & product research',
        description: 'save products, compare options, connect with suppliers',
    },
    {
        title: 'Access to vetted professionals and brands',
        description: 'architects, designers, and builders — all in one place',
    },
];

export function HDEIntroStep({ setIsValid }: StepContentProps) {
    useEffect(() => {
        setIsValid(true);
    }, [setIsValid]);

    return (
        <div className="flex flex-col gap-3 pb-10 pt-4 md:gap-[1.375rem] md:pt-28">
            <div className="flex flex-col gap-3 md:gap-[1.375rem]">
                <h2 className="w-79 text-4.5 font-medium uppercase leading-[1.1] tracking-[-0.026em] text-[#161616] md:w-full md:text-[1.314rem]">
                    Register for Home Design Evening and unlock your building
                    journey.
                </h2>
                <p className="w-83 text-3 leading-[1.3] tracking-[-0.015rem] text-[#3b3b3b] md:text-[0.875rem] md:tracking-[-0.018rem]">
                    <span className="font-medium text-black">
                        This takes about 1 minute.{' '}
                    </span>
                    The questions we ask will personalise both your evening and
                    your ArchiPro experience, connecting you with the right
                    products, professionals, and inspiration for your project.
                </p>
            </div>
            <ul className="flex flex-col gap-1 md:gap-[0.528rem]">
                {BENEFITS.map((benefit) => (
                    <li
                        key={benefit.title}
                        className="flex items-start gap-3 py-1 md:py-[0.625rem]"
                    >
                        <span className="flex size-[1.15rem] shrink-0 items-center justify-center rounded-full bg-white">
                            <Check className="text-grey-900 size-3" />
                        </span>
                        <div className="flex w-70 flex-col gap-[0.188rem] md:w-full">
                            <span className="text-[0.919rem] font-medium leading-[1.1] tracking-[-0.018em] text-black">
                                {benefit.title}
                            </span>
                            <span className="text-[0.8125rem] leading-[1.1] tracking-[-0.016em] text-[#858585]">
                                {benefit.description}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
